import { isTyped, TKey, TKeyValue, TKlankKeyValue } from '../../components/rid-syllabic-keyboard/rid-syllabic-keyboard.utils';

export interface IKeyboard {
  insert(key: TKey): void;
  highlight(keys: TKeyValue[]): void;
  clearHighlight(): void;
  getInput<T extends TKeyValue>(keys: T[]): Promise<T>;
  setDubbelzetter(active: boolean): void;
}

export class Langermaken {
  public constructor(private readonly keyboard: IKeyboard) {}

  public async apply(klank: 't' | 'p', allowPlakT = false) {
    this.keyboard.highlight(['b', 'd', 't', 'p']);

    const input = await this.keyboard.getInput(allowPlakT && klank === 't' ? ['→', '+t'] : ['→']);
    this.keyboard.clearHighlight();
    if (input === '→') {
      if (klank === 't') {
        const input2 = await this.keyboard.getInput(['t', 'd']);
        this.keyboard.insert({ type: 'KLANK', value: input2 });
      } else {
        const input2 = await this.keyboard.getInput(['p', 'b']);
        this.keyboard.insert({ type: 'KLANK', value: input2 });
      }
    } else {
      this.keyboard.insert({ type: 'EXCEPTION', value: '+t' });
    }
  }
}

export class Tekendief {
  public constructor(private readonly keyboard: IKeyboard) {}

  public async apply(klank: 'aa' | 'ee' | 'oo' | 'uu', allowLiteralKlank = false) {
    this.keyboard.highlight(allowLiteralKlank ? ['=ee'] : ['aa', 'ee', 'oo', 'uu']);
    const input = await this.keyboard.getInput(allowLiteralKlank ? ['=ee'] : ['-']);
    this.keyboard.clearHighlight();

    if (input === '=ee') {
      this.keyboard.insert({ type: 'EXCEPTION', value: '=ee' });
      return;
    }

    this.keyboard.insert({ type: 'KLANK', value: `${klank[0]}(${klank[0]})` as TKlankKeyValue });
  }
}

export class KortsteVorm {
  public constructor(private readonly keyboard: IKeyboard) {}

  public async apply(klank: 'au' | 'ou' | 'auw' | 'ouw' | 'ch' | 'g' | 'ng' | 'nk') {
    this.keyboard.highlight(['au', 'ou', 'auw', 'ouw', 'ch', 'g', 'ng', 'nk']);
    await this.keyboard.getInput(['←']);
    this.keyboard.clearHighlight();

    if (isTyped(klank, ['ch', 'g'])) {
      this.keyboard.insert({ type: 'KLANK', value: await this.keyboard.getInput(['ch', 'g']) });
    } else if (isTyped(klank, ['au', 'ou', 'auw', 'ouw'])) {
      this.keyboard.insert({ type: 'KLANK', value: await this.keyboard.getInput(['au', 'ou', 'auw', 'ouw']) });
    } else if (isTyped(klank, ['ng', 'nk'])) {
      this.keyboard.insert({ type: 'KLANK', value: await this.keyboard.getInput(['ng', 'nk']) });
    }
  }
}

export class Dubbelzetter {
  public constructor(private readonly keyboard: IKeyboard) {}

  public async apply(klank: 'a' | 'e' | 'i' | 'o' | 'u') {
    this.keyboard.highlight(['a', 'e', 'i', 'o', 'u']);
    this.keyboard.insert({ type: 'KLANK', value: klank });

    await this.keyboard.getInput(['+']);
    this.keyboard.clearHighlight();
    this.keyboard.setDubbelzetter(true);
  }
}
